import React from "react";
import AccessTab from "./AccessTab";
import ChatUxTab from "./ChatUxTab";
import DangerTab from "./DangerTab";
import EmailTab from "./EmailTab";
import GeneralTab from "./GeneralTab";
import KnowledgeTab from "./KnowledgeTab";
import ToolsTab from "./ToolsTab";

export default function AgentConfigTabContent({ activeTab, tabPropsById }) {
  if (activeTab === "general") return <GeneralTab {...tabPropsById.general} />;
  if (activeTab === "access") return <AccessTab {...tabPropsById.access} />;
  if (activeTab === "chatUx") return <ChatUxTab {...tabPropsById.chatUx} />;
  if (activeTab === "tools") return <ToolsTab {...tabPropsById.tools} />;
  if (activeTab === "knowledge") {
    return <KnowledgeTab {...tabPropsById.knowledge} />;
  }
  if (activeTab === "email") return <EmailTab {...tabPropsById.email} />;
  if (activeTab === "danger") return <DangerTab {...tabPropsById.danger} />;
  return null;
}
